import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import styled from "styled-components";
import { defaultOperators } from "constants/account/conditions";
import { isValidRegex } from "utils";
import BaseClause from "components/Common/Clauses/Base";
import Input from "components/Common/Forms/Input";

class Clause extends Component {
  static propTypes = {
    clause: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  getPrefixedValue(operator, value, prev) {
    const prefixedOperators = [
      defaultOperators.STARTS_WITH,
      defaultOperators.NOT_STARTS_WITH,
      defaultOperators.EXACT,
      defaultOperators.NOT_EXACT
    ];

    if (prefixedOperators.includes(operator) && `${value}`.charAt(0) !== "/") {
      if (prev && `${prev}`.charAt(0) === "/") {
        window.requestAnimationFrame(() =>
          this.valueInput.setSelectionRange(2, 2)
        );
      }
      return `/${value}`;
    }
    return value;
  }

  render() {
    const { clause, rule, updateClause, deleteClause, onBlur } = this.props;

    const operatorOptions = [
      { value: defaultOperators.STARTS_WITH, label: "starts with" },
      { value: defaultOperators.NOT_STARTS_WITH, label: "doesn't start with" },
      { value: defaultOperators.ENDS_WITH, label: "ends with" },
      { value: defaultOperators.NOT_ENDS_WITH, label: "doesn't end with" },
      { value: defaultOperators.CONTAINS, label: "contains" },
      { value: defaultOperators.NOT_CONTAINS, label: "doesn't contain" },
      { value: defaultOperators.EXACT, label: "equals" },
      { value: defaultOperators.NOT_EXACT, label: "doesn't equal" },
      { value: defaultOperators.REGEX, label: "matches regex" }
    ];

    const onValueChange = e => {
      const value = e.nativeEvent.target.textContent || e.target.value;
      updateClause(clause.id, {
        value: this.getPrefixedValue(clause.operator, value, clause.value)
      });
    };

    let placeholder = "";
    try {
      placeholder = `e.g. ${new URL(rule.previewUrl).pathname}`;
    } catch (e) {
      placeholder = "e.g. /account";
    }

    const isRegex = clause.operator === defaultOperators.REGEX;
    const isRegexValid = isRegex && isValidRegex(clause.value);

    return (
      <BaseClause
        {...this.props}
        deleteClause={deleteClause}
        className={"base-clause"}
      >
        <Select
          className="select-condition-name"
          clearable={false}
          value={clause.operator}
          options={operatorOptions}
          onBlur={onBlur || (() => {})}
          onChange={opt => {
            updateClause(clause.id, {
              operator: opt.value,
              value: this.getPrefixedValue(opt.value, clause.value || "")
            });
          }}
        />
        <Input
          type="text"
          ref={input => {
            this.valueInput = input;
          }}
          value={clause.value || ""}
          placeholder={placeholder}
          onChange={onValueChange}
          onBlur={onBlur || (() => {})}
          className={isRegex ? (isRegexValid ? "valid" : "invalid") : ""}
        />
      </BaseClause>
    );
  }
}

export default styled(Clause)`
  .base-clause {
    input {
      &.valid {
        color: ${props => props.theme["$green-dark"]};
      }
      &.invalid {
        color: ${props => props.theme["$orange-2"]};
      }
    }
  }
`;
